export default function initGalleryBacktop() {
  const trigger = document.querySelector('[data-gallery-backtop]');

  if (!trigger) return;

  const targetSelector = trigger.getAttribute('href') || '#gallery-top';
  const target = document.querySelector(targetSelector);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visibleOffset = 700;

  let ticking = false;

  function updateVisibility() {
    trigger.classList.toggle('is-visible', window.scrollY > visibleOffset);
    ticking = false;
  }

  function handleScroll() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  trigger.addEventListener('click', function (event) {
    if (!target) return;

    event.preventDefault();

    target.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  window.addEventListener('scroll', handleScroll, { passive: true });

  updateVisibility();
}